/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentDraftsControllerCreateMutationRequest, DocumentDraftsControllerCreateMutationResponse, DocumentDraftsControllerCreate400, DocumentDraftsControllerCreate401, DocumentDraftsControllerCreate403 } from "../../models/documentDraftsController/DocumentDraftsControllerCreate";

function getDocumentDraftsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/document-drafts` as const }  
  return res
}

/**
 * {@link /api/v1/document-drafts}
 */
export async function documentDraftsControllerCreate(data?: DocumentDraftsControllerCreateMutationRequest, config: Partial<RequestConfig<DocumentDraftsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<DocumentDraftsControllerCreateMutationResponse, ResponseErrorConfig<DocumentDraftsControllerCreate400 | DocumentDraftsControllerCreate401 | DocumentDraftsControllerCreate403>, DocumentDraftsControllerCreateMutationRequest>({ method : "POST", url : getDocumentDraftsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}